module.exports = __webpack_public_path__ + "static/img/__7871.74c0569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__7871.jpg
// module id = gpmC
// module chunks = 0